<template>
    <div class="main-con el-main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "ProxyPerson"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ProxyPerson.vue